import * as React from 'react';
import cn from 'classnames';
import { useMediaQuery } from 'react-responsive';
import { useTheme } from '../../../theme';
import { initI18n, MOBILE_MIN_WIDTH } from '../../../utils';
import Dropdown from '../../../Dropdown';
import SlideBottom from '../../../SlideBottom';
initI18n('FlightInfoCardControls');
const FlightInfoCardControls = ({ controls, isOpened, onClose, outsideClickIgnoreClass }) => {
    const { FlightInfoCardControls: css } = useTheme('FlightInfoCard');
    const isMobile = useMediaQuery({ query: `(max-width: ${MOBILE_MIN_WIDTH}px)` });
    const renderControls = React.useMemo(() => (React.createElement("div", { className: cn(css.controls) }, controls.map(control => (React.createElement("div", { key: control.name, className: cn(css.controls__item), onClick: () => {
            onClose();
            control.onClick();
        } },
        React.createElement("span", { className: cn(css.controls__img) }, control.icon),
        control.name))))), [controls]);
    return isMobile ? (React.createElement(SlideBottom, { isOpen: isOpened, onClose: onClose }, renderControls)) : (React.createElement(Dropdown, { isOpen: isOpened, onClose: onClose, outsideClickIgnoreClass: outsideClickIgnoreClass }, renderControls));
};
export default FlightInfoCardControls;
